<div class="container">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 divPrincipal" *ngIf=" !existForm || numberForm == 0 ">
        <div class="tramite">
            <div class="row">
                <h1 class="servicioSpan">¿Qué trámite desea hacer?</h1>
                <div *ngFor=" let materia of materias; let i = index "
                    [ngStyle]="{'display':(materia.active)?'inline':'none'}"
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                    <div *ngIf="materia.active" (click)="openForms(materia.num)">
                        <div style="height:150px" class="form-tramites">
                            <h4>{{materia.num }} {{materia.name}} </h4>
                            <!-- <img [src]="iconosPermisos[materia.num-1]"> -->
                            <img style="max-width: 150px; max-height: 150px;"
                                src="assets/permisos/{{materia.icon}}.svg">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>